import React, { Component } from "react";
import { Dropdown } from "semantic-ui-react";
import { toast } from "react-toastify";
import "./UpdateAssignedStatus.scss";
import Modal from "../../../UIComponents/CustomModal/Modal";
import moment from "moment";

class UpdateAssignedStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            assignedStatus: null,
        };
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.assignedStatus) this.setState({ assignedStatus: newProps.assignedStatus.sync_status });
    }

    updateAssignedStatus = () => {
        this.props.updateAssignedStatus({ data: this.props.assignedStatus.data, sync_status: this.state.assignedStatus });
        this.props.hideModal();
    };

    handleAssignedStatus = (val) => {
        // console.log(val);
        this.setState({ assignedStatus: val });
    };

    render() {
        const statusOptions = [
            { key: "open", text: "Open", value: "opened" },
            { key: "assigned", text: "Shared", value: "assigned" },
            { key: "closed", text: "Closed", value: "closed" },
            { key: "archived", text: "Archived", value: "archived" },
        ].map((s) => {
            if (this.props.assignedStatus && s.value === this.props.assignedStatus.sync_status) return { ...s, text: s.text + " - Current" };
            else return s;
        });
        // console.log(statusOptions);
        return (
            <Modal className={`change-review-status-modal`} show={this.props.open} onClose={() => this.props.hideModal()}>
                <Modal.Header>Change Review Status</Modal.Header>
                <Modal.Content>
                    <p>Select an Assign Type from the dropdown below for your post.</p>
                    <Dropdown
                        value={this.state.assignedStatus}
                        onChange={(e, d) => this.handleAssignedStatus(d.value)}
                        placeholder="Collection"
                        fluid
                        search
                        selection
                        className="collection-pick"
                        options={statusOptions}
                    />
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton normal onClick={() => this.props.hideModal()}>
                        Cancel
                    </Modal.ActionButton>
                    <Modal.ActionButton filled onClick={this.updateAssignedStatus}>
                        Update
                    </Modal.ActionButton>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default UpdateAssignedStatus;
